<template>
  <div>
    <v-dialog v-model="plan.open" width="700" scrollable @click:outside="$emit('close')">
      <v-card class="py-5">
        <v-card-text>
          <v-container>
            <v-row v-if="$vuetify.breakpoint.smAndDown">
              <v-col cols="12" class="d-flex justify-end pb-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" fab dark color="red" x-small v-bind="attrs" v-on="on" @click="$emit('close')">
                      <v-icon dark> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cerrar</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row justify="center" class="text-center">
              <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="12" class="d-flex justify-center">
                <v-img src="@/assets/logo.png" max-height="50" max-width="50" />
              </v-col>
              <v-col cols="12">
                <h1 class="mb-5">Resumen de compra</h1>
                <p>
                  <span class="display-3 font-weight-medium mr-3 accent--text">{{ plan.balance }}</span>
                  <span class="title font-weight-bold">Registros</span>
                </p>
              </v-col>
              <v-col cols="12" class="around-margin">
                <v-row>
                  <p class="title font-weight-bold ml-5">
                    Información de tarjeta
                  </p>
                </v-row>
                <form>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-text-field label="Nombre(s) del titular" v-model="name" filled rounded />
                      <v-text-field label="Correo" filled rounded v-model="email" />
                      <v-col cols="12">
                        <v-stripe-card v-model="source" :api-key="apiKey" :hidePostalCode="true" :key="stripeComponentKey"
                          ref="stripeRef" :disabled="false" />
                      </v-col>
                    </v-col>
                  </v-row>
                </form>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox v-model="terms" color="primary" hide-details>
                  <template v-slot:label>
                    <span>
                      Acepto los&nbsp;
                      <router-link to="/terminos-y-condiciones" v-slot="{ href }">
                        <a :href="href" target="_blank" @click.stop>Términos y Condiciones
                        </a>
                      </router-link>
                    </span>
                  </template>
                </v-checkbox>
                <p class="pt-4">
                  <b>Nota:</b> Tendrás hasta fin de mes para generar tu factura
                  usando el ID que recibirás en el correo de confirmación
                </p>
              </v-col>
            </v-row>
            <v-row justify="end">
              <v-col cols="12" class="py-0">
                <p class="font-weight-bold title text-right mb-0">Total:</p>
              </v-col>
              <v-col cols="12" class="py-0">
                <p class="secondary--text text-right text-h3 font-weight-bold mb-0">
                  {{ formatNumber(plan.price) }}
                </p>
              </v-col>
            </v-row>

            <v-row class="d-flex pb-2 mt-10" :class="$vuetify.breakpoint.smAndUp ? 'justify-end' : 'justify-center'
              ">
              <span class="font-weight-bold ma-2">
                ¿Cómo facturo?
                <v-tooltip top max-width="400">
                  <template #activator="{ on, attrs }">
                    <v-icon color="black" v-on="on" v-bind="attrs" class="ml-2">
                      fas fa-question-circle
                    </v-icon>
                  </template>
                  <span>
                    Una ves realizada la compra, serás redirigido al apartado
                    donde podrás timbrar tu factura gracias al ID de la compra
                    que aparecerá en el correo
                  </span>
                </v-tooltip>
              </span>
              <div class="ma-2">
                <action-button variant="secondary" elevation="0" @click="$emit('back')">
                  Atrás
                </action-button>
              </div>
              <div class="ma-2">
                <action-button @click="finishBuying()" elevation="0" variant="accent" textColor="white"
                  :disabled="isButtonDisabled || !terms" :loading="paymentButtonLoader">
                  Finalizar compra
                </action-button>
              </div>
            </v-row>
          </v-container>
        </v-card-text>
        <!--<v-card-actions class="d-flex justify-space-around mt-2">
          <span class="font-weight-bold">
            ¿Cómo facturo?
            <v-tooltip top max-width="400">
              <template #activator="{ on, attrs }">
                <v-icon color="black" v-on="on" v-bind="attrs" class="ml-2">
                  fas fa-question-circle
                </v-icon>
              </template>
              <span>
                Una vez finalizada tu compra puedes visualizar y descargar tu
                factura de esta compra o cualquier otra en tu Tablero Principal
                en el apartado de <strong>"Mis compras"</strong>.
              </span>
            </v-tooltip>
          </span>
          <action-button variant="secondary" elevation="0" @click="$emit('back')">
            Atrás
          </action-button>
          <action-button @click="finishBuying()" :disabled="isButtonDisabled">
            Finalizar Compra
          </action-button>
        </v-card-actions>-->
      </v-card>
    </v-dialog>
    <thanks-modal :open="thanksForBuyingModal" :balance="plan.balance" :purchaseId="plan.purchaseId"
      @close="thanksForBuyingModal = false" />
  </div>
</template>
<script>
import VStripeCard from "v-stripe-elements/lib/VStripeCard";

import ActionButton from "@/components/shared/ActionButton";
import Endpoints from "@/share/Endpoints";
import ThanksModal from "./ThanksModal";
import { mapMutations, mapActions } from "vuex";

export default {
  components: {
    VStripeCard,
    ActionButton,
    ThanksModal,
  },
  props: ["plan"],
  data: () => ({
    apiKey: process.env.VUE_APP_STRIPE_API_KEY,
    thanksForBuyingModal: false,
    source: "",
    cardPaymentIntentId: "",
    stripeComponentKey: 0,
    name: "",
    email: "",
    terms: false,
    paymentButtonLoader: false,
  }),
  methods: {
    ...mapActions("user", ["getIndicators"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapMutations("notification", ["show"]),
    async finishBuying() {
      try {
        this.loading();
        let response = await this.axios({
          method: "post",
          url: Endpoints.executeInternalCardPayement,
          json: true,
          data: {
            payment: {
              paymentIntentId: this.cardPaymentIntentId,
            },
          },
        });
        // Consultar los datos del usuario pra obtener los registros que tiene disponibles
        setTimeout(async () => {
          await this.getIndicators();
        }, 1500);
        this.thanksForBuyingModal = true;
        this.$emit("close");
      } catch (error) {
        this.show({
          text:
            error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "Hubo un problema al ejecutar la orden",
          color: "error",
        });
      } finally {
        this.loaded();
      }
    },
    formatNumber: (number) =>
      new Intl.NumberFormat("es-mx", {
        style: "currency",
        currency: "MXN",
      }).format(number),
  },
  computed: {
    isButtonDisabled() {
      return !(this.cardPaymentIntentId && this.name);
    },
  },
  watch: {
    source: async function () {
      this.paymentButtonLoader = true;
      const { card, stripe } = this.$refs.stripeRef;

      const { paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card,
        billing_details: { name: this.name, email: this.email },
      });

      const { data } = await this.axios({
        method: "post",
        url: Endpoints.internalCardPayementIntent,
        data: {
          paymentMethod: { id: paymentMethod.id, total: this.plan.price },
          purchaseId: this.plan.purchaseId,
        },
      });

      this.cardPaymentIntentId = data.paymentIntent.id;
      this.paymentButtonLoader = false;
    },
  },
};
</script>